module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABEElEQVQ4T+3TsUrEQBAG4H/2DfIWvoHNgcXVFlpY3FkJIogwCQh2klabZBILyRPIpdVCFMXCl/AB0loZEHVHAneQC5e9nHedt7DNMnzs/jNLWPGiFXtYg8snOpUhMx8ZY96jKBp1oYMg2FLVfhzH55P6JngM4EpVB0mS3LhQZu4BuK+2iOzOBKtD3/dPVfXShdawV2vtdpqmn63gBAVwYa0dNm/KzJsAnojouSzLnSzLvuovaZ1DZj4hIqmjY+wRwIPneXthGH43Y3EOdh01xryp6guA26Io9vM8/5mV8dyfwsyHRHQN4ENV70RkAEDbGjYXHGd6oKobInLmwqraTmCXmXR2eRFgoab8Bf6HT/4FraxvFTYxzloAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow.png
// module id = 3Uj3
// module chunks = 0